import axios from "axios";

import baseURL from '@/utils/url'
import { Message } from 'element-ui'
// 使用自定义的配置文件发送请求
const instance = axios.create({
  baseURL: baseURL,
  timeout: 50000,
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});

// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {

    // 可以设置token
    // config.header["token"] = "";
    // config.header["content-type"] = "multipart/form-data";
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  (response) => {
    instance;
   
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default instance;
